import {
  litanyLauretanaMeta,
  litanyLauretanaSections,
  litanyLauretanaVerses,
} from './litanyLauretana';
import { RDM_KEYS, divineMercyPrayers } from './divineMercyData';

const RosarioPrayerBook = {

  // structure of the physical rosary
  PRo:[
    
  ],
  // this describes the order of the prayers
  RGo: [
    "SC",
    "AC",
    "C",
    "P",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG1",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG2",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG3",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG4",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG5",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "LL",
    "S",
  ],
  RDo: [
    "SC",
    "AC",
    "C",
    "P",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MD1",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MD2",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MD3",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MD4",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MD5",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "LL",
    "S",
  ],
  RGl: [
    "SC",
    "AC",
    "C",
    "P",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG1",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG2",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG3",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG4",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "MG5",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "LL",
    "S",
  ],
  RL: [
    "SC",
    "AC",
    "C",
    "P",
    "A",
    "A",
    "A",
    "G",
    "F",
    "ML1",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "ML2",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "ML3",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "ML4",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "ML5",
    "P",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "A",
    "G",
    "F",
    "LL",
    "S",
  ],
  apertura: [
    {
      id: "SC",
      title: "Señal de la Cruz",
      img: "/gallery-images/cathedral praing.jpg",
      // imglight deferred — dual light/dark revamp later
      text: "En el nombre del Padre,\ny del Hijo,\ny del Espíritu Santo.\nAmén.",
    },
    {
      id: "AC",
      title: "Acto de Contrición",
      img: "/gallery-images/misterios/modooscuro/contricion.jpg",
      imgmo: "/gallery-images/misterios/modooscuro/contricion.jpg",
      imglight: "/gallery-images/misterios/modooscuro/contricion.jpg",
      text: "Yo confieso ante Dios todopoderoso\ny ante vosotros, hermanos,\nque he pecado mucho\nde pensamiento, palabra, obra y omisión.\n\nPor mi culpa, por mi culpa, por mi gran culpa.\n\nPor eso ruego a Santa María, siempre Virgen,\na los ángeles, a los santos\ny a vosotros, hermanos,\nque intercedáis por mí ante Dios, nuestro Señor.\nAmén.",
    },
    {
      id: "C",
      title: "Credo",
      img: "/gallery-images/misterios/modooscuro/credo.webp",
      imgmo: "/gallery-images/misterios/modooscuro/credo.webp",
      imglight: "/gallery-images/img-texto-rezos/latin-credo.jpeg",
      text: "Creo en Dios, Padre todopoderoso,\nCreador del cielo y de la tierra.\n\nCreo en Jesucristo, su único Hijo, nuestro Señor,\nque fue concebido por obra y gracia del Espíritu Santo,\nnació de Santa María Virgen,\npadeció bajo el poder de Poncio Pilato,\nfue crucificado, muerto y sepultado,\ndescendió a los infiernos,\nal tercer día resucitó de entre los muertos,\nsubió a los cielos\ny está sentado a la derecha de Dios, Padre todopoderoso.\nDesde allí ha de venir a juzgar a vivos y muertos.\n\nCreo en el Espíritu Santo,\nla santa Iglesia católica,\nla comunión de los santos,\nel perdón de los pecados,\nla resurrección de la carne\ny la vida eterna.\nAmén.",
    },
  ],
  decada: [
    {
      id: "P",
      title: "Padre Nuestro",
      img: "/gallery-images/misterios/modooscuro/padre-nuestro.jpg",
      imgmo: "/gallery-images/misterios/modooscuro/padre-nuestro.jpg",
      imglight: "/gallery-images/img-texto-rezos/latin-pater-noster.jpg",
      text: "Padre nuestro, que estás en el cielo, santificado sea tu nombre; venga a nosotros tu reino; hágase tu voluntad en la tierra como en el cielo. Danos hoy nuestro pan de cada día; perdona nuestras ofensas, como también nosotros perdonamos a los que nos ofenden; no nos dejes caer en la tentación, y líbranos del mal. Amén.",
      scripture: "Matthew 6:9-13"
    },
    {
      id: "A",
      title: "Ave María",
      img: "/gallery-images/misterios/modooscuro/ave-maria.jpg",
      imgmo: "/gallery-images/misterios/modooscuro/ave-maria.jpg",
      imglight: "/gallery-images/img-texto-rezos/latin-ave-maria.jpg",
      text: "Dios te salve, María, \nllena eres de gracia, \nel Señor es contigo. \nBendita tú eres entre todas las mujeres, \ny bendito es el fruto de tu vientre, \nJesús. \nSanta María, \nMadre de Dios, \nruega por nosotros, pecadores, \nahora y en la hora de nuestra muerte. \nAmén.",
      scriptureId: "A"
    },
    {
      id: "G",
      title: "Gloria",
      img: "/gallery-images/misterios/modooscuro/gloria.webp",
      imgmo: "/gallery-images/misterios/modooscuro/gloria.webp",
      imglight: "/gallery-images/img-texto-rezos/latin-gloria.jpg",
      text: "Gloria al Padre, y al Hijo, y al Espíritu Santo. Como era en el principio, ahora y siempre, por los siglos de los siglos. Amén.",
    },
    {
      id: "F",
      title: "Oración de Fátima",
      img: "/gallery-images/misterios/modooscuro/roseLimaJuarez-870x1250.jpg",
      imgmo: "/gallery-images/misterios/modooscuro/roseLimaJuarez-870x1250.jpg",
      imglight: "/gallery-images/misterios/Encounters in the cathedral of Raleigh.jpg",
      text: "Oh Jesús mío, perdona nuestros pecados, líbranos del fuego del infierno, lleva al cielo a todas las almas, especialmente a las más necesitadas de tu misericordia.",
    },
  ],
  mysteries: {
    gozosos: [
      "/gallery-images/misterios/modooscuro/misteriogozo0.webp",
      null,
      {
        id: "MG1",
        num: 1,
        title: "MG1: La Anunciación del Ángel a María",
        img: "/gallery-images/misterios/litografia/misteriogozo1.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriogozo1.webp",
        text: "El arcángel Gabriel anuncia a María que será la Madre del Salvador\n\nCitas Escriturísticas:\n\nLucas 1:28: Y entrando el ángel en donde ella estaba, dijo: ¡Salve, muy favorecida! El Señor es contigo; bendita tú entre las mujeres.\nLucas 1:38: Entonces María dijo: He aquí la sierva del Señor; hágase conmigo conforme a tu palabra.\nIsaías 7:14: Por tanto, el Señor mismo os dará señal: He aquí que la virgen concebirá, y dará a luz un hijo, y llamará su nombre Emanuel.",
      },
      {
        id: "MG2",
        num: 2,
        title: "MG2: La Visitación de María a su prima Isabel",
        img: "/gallery-images/misterios/litografia/misteriogozo2.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriogozo2.webp",
        text: "María visita a su prima Isabel, quien reconoce en ella a la Madre del Señor\n\nCitas Escriturísticas:\n\nLucas 1:42-43: Y exclamó a gran voz, y dijo: Bendita tú entre las mujeres, y bendito el fruto de tu vientre. ¿Por qué se me concede esto a mí, que la madre de mi Señor venga a mí?\nLucas 1:46-47: Entonces María dijo: Engrandece mi alma al Señor; Y mi espíritu se regocija en Dios mi Salvador.\nLucas 1:41: Y aconteció que cuando oyó Isabel la salutación de María, la criatura saltó en su vientre; e Isabel fue llena del Espíritu Santo.",
      },
      {
        id: "MG3",
        num: 3,
        title: "MG3: El Nacimiento de Jesús en Belén",
        img: "/gallery-images/misterios/litografia/misteriogozo3.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriogozo3.webp",
        text: "El Verbo se hace carne y nace de la Virgen María en Belén\n\nCitas Escriturísticas:\n\nJuan 1:14: Y aquel Verbo fue hecho carne, y habitó entre nosotros (y vimos su gloria, gloria como del unigénito del Padre), lleno de gracia y de verdad.\nLucas 2:7: Y dio a luz a su hijo primogénito, y lo envolvió en pañales, y lo acostó en un pesebre, porque no había lugar para ellos en el mesón.\nLucas 2:10-11: Pero el ángel les dijo: No temáis; porque he aquí os doy nuevas de gran gozo, que será para todo el pueblo: que os ha nacido hoy, en la ciudad de David, un Salvador, que es CRISTO el Señor.",
      },
      {
        id: "MG4",
        num: 4,
        title: "MG4: La Presentación del Niño Jesús en el Templo",
        img: "/gallery-images/misterios/litografia/misteriogozo4.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriogozo4.webp",
        text: "María y José presentan al Niño Jesús en el Templo, donde es reconocido por Simeón y Ana\n\nCitas Escriturísticas:\n\nLucas 2:29-30: Ahora, Señor, despides a tu siervo en paz, Conforme a tu palabra; Porque han visto mis ojos tu salvación.\nLucas 2:34-35: Y los bendijo Simeón, y dijo a su madre María: He aquí, éste está puesto para caída y para levantamiento de muchos en Israel, y para señal que será contradicha; y una espada traspasará tu misma alma.\nLevítico 12:6-8: Y cuando los días de su purificación fueren cumplidos, por hijo o por hija, traerá un cordero de un año para holocausto, y un palomino o una tórtola para expiación.",
      },
      {
        id: "MG5",
        num: 5,
        title: "MG5: El Niño Jesús perdido y hallado en el Templo",
        img: "/gallery-images/misterios/litografia/misteriogozo5.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriogozo5.webp",
        text: "Jesús, a los doce años, se queda en el Templo enseñando a los doctores\n\nCitas Escriturísticas:\n\nLucas 2:46-47: Y aconteció que tres días después le hallaron en el templo, sentado en medio de los doctores de la ley, oyéndoles y preguntándoles. Y todos los que le oían, se maravillaban de su inteligencia y de sus respuestas.\nLucas 2:49: Entonces él les dijo: ¿Por qué me buscabais? ¿No sabíais que en los negocios de mi Padre me es necesario estar?\nLucas 2:52: Y Jesús crecía en sabiduría y en estatura, y en gracia para con Dios y los hombres.",
      },
    ],
    dolorosos: [
      "/gallery-images/misterios/modooscuro/misteriodolor0.jpg",
      {
        id: "MD1",
        num: 1,
        title: "MD1: La Oración de Jesús en el Huerto",
        img: "/gallery-images/misterios/litografia/misteriodolor1.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriodolor1.webp",
        alt: "Jesús ora en Getsemaní con gran angustia, sudando sangre antes de ser arrestado",
        text: "Lucas 22:42: Diciendo: Padre, si quieres, pasa de mí esta copa; pero no se haga mi voluntad, sino la tuya.\n\nLucas 22:44: Y estando en agonía, oraba más intensamente; y era su sudor como grandes gotas de sangre que caían hasta la tierra.\n\nMateo 26:38: Entonces Jesús les dijo: Mi alma está muy triste, hasta la muerte; quedaos aquí, y velad conmigo.",
      },
      {
        id: "MD2",
        num: 2,
        title: "MD2: La Flagelación del Señor",
        img: "/gallery-images/misterios/litografia/misteriodolor2.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriodolor2.jpg",
        alt: "Jesús es azotado por orden de Pilato antes de ser crucificado",
        text: "Mateo 27:26: Entonces les soltó a Barrabás; y habiendo azotado a Jesús, le entregó para ser crucificado.\n\nIsaías 53:5: Mas él herido fue por nuestras rebeliones, molido por nuestros pecados; el castigo de nuestra paz fue sobre él, y por su llaga fuimos nosotros curados.\n\n1 Pedro 2:24: Quien llevó él mismo nuestros pecados en su cuerpo sobre el madero, para que nosotros, estando muertos a los pecados, vivamos a la justicia; y por cuya herida fuisteis sanados.",
      },
      {
        id: "MD3",
        num: 3,
        title: "MD3: La Coronación de Espinas",
        img: "/gallery-images/misterios/litografia/misteriodolor3.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriodolor3.webp",
        alt: "Los soldados coronan a Jesús con espinas y se burlan de Él como Rey de los judíos",
        text: "Mateo 27:29: Y pusieron sobre su cabeza una corona tejida de espinas, y una caña en su mano derecha; e hincando la rodilla delante de él, le escarnecían, diciendo: ¡Salve, Rey de los judíos!\n\nJuan 19:5: Y salió Jesús, llevando la corona de espinas y el manto de púrpura. Y Pilato les dijo: ¡He aquí el hombre!\n\nIsaías 52:14: Como se asombraron de ti muchos, de tal manera fue desfigurado de los hombres su parecer, y su hermosura más que la de los hijos de los hombres.",
      },
      {
        id: "MD4",
        num: 4,
        title: "MD4: Jesús con la Cruz a cuestas",
        img: "/gallery-images/misterios/litografia/misteriodolor4.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriodolor4.webp",
        alt: "Jesús carga la cruz camino al Calvario, ayudado por Simón de Cirene",
        text: "Juan 19:17: Y él, cargando su cruz, salió al lugar llamado de la Calavera, y en hebreo, Gólgota.\n\nLucas 23:26: Y llevándole, tomaron a cierto Simón de Cirene, que venía del campo, y le pusieron encima la cruz para que la llevase tras Jesús.\n\nMateo 16:24: Entonces Jesús dijo a sus discípulos: Si alguno quiere venir en pos de mí, niéguese a sí mismo, y tome su cruz, y sígame.",
      },
      {
        id: "MD5",
        num: 5,
        title: "MD5: La Crucifixión y Muerte de Nuestro Señor",
        img: "/gallery-images/misterios/litografia/misteriodolor5.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriodolor5.jpg",
        alt: "Jesús es crucificado y muere en la cruz, perdonando a sus verdugos y entregando su espíritu",
        text: "Juan 19:30: Cuando Jesús hubo tomado el vinagre, dijo: Consumado es. Y habiendo inclinado la cabeza, entregó el espíritu.\n\nLucas 23:46: Entonces Jesús, clamando a gran voz, dijo: Padre, en tus manos encomiendo mi espíritu. Y habiendo dicho esto, expiró.\n\nIsaías 53:7: Angustiado él, y afligido, no abrió su boca; como cordero fue llevado al matadero; y como oveja delante de sus trasquiladores, enmudeció, y no abrió su boca.",
      },
    ],
    gloriosos: [
      "/gallery-images/misterios/modooscuro/misteriogloria0.jpg",
      {
        id: "MG1",
        num: 1,
        title: "MG1: La Resurrección del Señor",
        img: "/gallery-images/misterios/litografia/misteriogloria1.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriogloria1.webp",

        text: "Jesús resucita de entre los muertos al tercer día, venciendo la muerte\n\nCitas Escriturísticas:\n\nMateo 28:6: No está aquí, pues ha resucitado, como dijo. Venid, ved el lugar donde fue puesto el Señor.\n1 Corintios 15:20: Mas ahora Cristo ha resucitado de los muertos; primicias de los que durmieron es hecho.\nRomanos 6:9: Sabiendo que Cristo, habiendo resucitado de los muertos, ya no muere; la muerte no se enseñorea más de él.",
      },
      {
        id: "MG2",
        num: 2,
        title: "MG2: La Ascensión del Señor",
        img: "/gallery-images/misterios/litografia/misteriogloria2.jpg",

        imgmo: "/gallery-images/misterios/modooscuro/misteriogloria2.webp",
        text: "Jesús asciende a los cielos delante de sus discípulos\n\nCitas Escriturísticas:\n\nHechos 1:9: Y habiendo dicho estas cosas, viéndolo ellos, fue alzado, y le recibió una nube que le ocultó de sus ojos.\nMarcos 16:19: Y el Señor, después que les habló, fue recibido arriba en el cielo, y se sentó a la diestra de Dios.\nEfesios 4:10: El que descendió, es el mismo que también subió por encima de todos los cielos para llenarlo todo.",
      },
      {
        id: "MG3",
        num: 3,
        title: "MG3: La Venida del Espíritu Santo",
        img: "/gallery-images/misterios/litografia/misteriogloria3.jpg",

        imgmo: "/gallery-images/misterios/modooscuro/misteriogloria3.webp",
        text: "El Espíritu Santo desciende sobre los Apóstoles y María en Pentecostés\n\nCitas Escriturísticas:\n\nHechos 2:4: Y fueron todos llenos del Espíritu Santo, y comenzaron a hablar en otras lenguas, según el Espíritu les daba que hablasen.\nJuan 14:26: Mas el Consolador, el Espíritu Santo, a quien el Padre enviará en mi nombre, él os enseñará todas las cosas, y os recordará todo lo que yo os he dicho.\nHechos 1:8: Pero recibiréis poder, cuando haya venido sobre vosotros el Espíritu Santo, y me seréis testigos en Jerusalén, en toda Judea, en Samaria, y hasta lo último de la tierra.",
      },
      {
        id: "MG4",
        num: 4,
        title: "MG4: La Asunción de María Santísima",
        img: "/gallery-images/misterios/litografia/misteriogloria4.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriogloria4.webp",
        text: "María es elevada en cuerpo y alma a la gloria celestial\n\nCitas Escriturísticas:\n\nLucas 1:48: Porque ha mirado la bajeza de su sierva; pues he aquí, desde ahora me dirán bienaventurada todas las generaciones.\nCantares 2:10-13: Mi amado habló, y me dijo: Levántate, oh amiga mía, hermosa mía, y ven. Porque, mira, ha pasado ya el invierno, han cesado las lluvias y se han ido. Muéstrame tu semblante, déjame oír tu voz; porque tu voz es dulce, y bello tu semblante.",
      },
      {
        id: "MG5",
        num: 5,
        title:
          "MG5: La Coronación de María como Reina del Cielo y de la Tierra",
        img: "/gallery-images/misterios/litografia/misteriogloria5.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misteriogloria5.webp",
        text: "María es coronada Reina del universo junto a su Hijo\n\nCitas Escriturísticas:\n\nApocalipsis 12:1: Apareció en el cielo una gran señal: una mujer vestida del sol, con la luna debajo de sus pies, y sobre su cabeza una corona de doce estrellas.\nSalmo 45:9: Está la reina a tu diestra con oro de Ofir.\nJeremías 13:18: Di al rey y a la reina: Humillaos, sentaos en tierra; porque la corona de vuestra gloria caerá de vuestras cabezas.",
      },
    ],
    luminosos: [
      "/gallery-images/misterios/modooscuro/misterioLUZ0.webp",
      {
        id: "ML1",
        num: 1,
        title: "ML1: El Bautismo de Jesús en el Jordán",
        img: "/gallery-images/misterios/litografia/misterioLUZ1.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misterioLUZ1.webp",
        text: "En esos días Jesús vino de Nazaret, pueblo de Galilea, y se hizo bautizar por Juan en el río Jordán. Cuando salió del agua, los Cielos se rasgaron para él y vio al Espíritu Santo que bajaba sobre él como paloma. Y del Cielo llegaron estas palabras: 'Tú eres mi Hijo, el Amado; tú eres mi Elegido'.\n\nY yo le vi, y he dado testimonio de que éste es el Hijo de Dios. Juan 1:34",
      },
      {
        id: "ML2",
        num: 2,
        title: "ML2: Las Bodas de Caná",
        img: "/gallery-images/misterios/litografia/misterioLUZ2.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misterioLUZ2.webp",
        text: "Su madre dijo a los que servían: Haced todo lo que él os dijere. Juan 2:5\n\nY faltando el vino, la madre de Jesús le dijo: No tienen vino. Jesús le dijo: ¿Qué tienes conmigo, mujer? Aún no ha venido mi hora. Juan 2:3-4\n\nJuan 2:11: Este principio de señales hizo Jesús en Caná de Galilea, y manifestó su gloria; y sus discípulos creyeron en él.",
      },
      {
        id: "ML3",
        num: 3,
        title: "ML3: El Anuncio del Reino de Dios",
        img: "/gallery-images/misterios/litografia/misterioLUZ3.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misterioLUZ3.webp",
        text: "Diciendo: El tiempo se ha cumplido, y el reino de Dios se ha acercado; arrepentíos, y creed en el evangelio. Marcos 1:15\n\nMateo 5:3: Bienaventurados los pobres en espíritu, porque de ellos es el reino de los cielos.\n\nLucas 4:43: Pero él les dijo: Es necesario que también a otras ciudades anuncie el evangelio del reino de Dios; porque para esto he sido enviado.",
      },
      {
        id: "ML4",
        num: 4,
        title: "ML4: La Transfiguración",
        img: "/gallery-images/misterios/litografia/misterioLUZ4.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misterioLUZ4.webp",
        text: "Y se transfiguró delante de ellos, y resplandeció su rostro como el sol, y sus vestidos se hicieron blancos como la luz. Mateo 17:2\n\nMateo 17:5: Mientras él aún hablaba, una nube de luz los cubrió; y he aquí una voz desde la nube, que decía: Este es mi Hijo amado, en quien tengo complacencia; a él oíd.\n\n2 Pedro 1:17-18: Pues cuando él recibió de Dios Padre honra y gloria, le fue enviada desde la magnífica gloria una voz que decía: Este es mi Hijo amado, en el cual tengo complacencia. Y nosotros oímos esta voz enviada del cielo, cuando estábamos con él en el monte santo.",
      },
      {
        id: "ML5",
        num: 5,
        title: "ML5: La Institución de la Eucaristía",
        img: "/gallery-images/misterios/litografia/misterioLUZ5.jpg",
        imgmo: "/gallery-images/misterios/modooscuro/misterioLUZ5.webp",
        text: "Yo soy el pan vivo que descendió del cielo; si alguno comiere de este pan, vivirá para siempre; y el pan que yo daré es mi carne, la cual yo daré por la vida del mundo. Juan 6:51\n\nY habiendo dado gracias, lo partió, y dijo: Tomad, comed; esto es mi cuerpo que por vosotros es partido; haced esto en memoria de mí. Asimismo tomó también la copa, después de haber cenado, diciendo: Esta copa es el nuevo pacto en mi sangre; haced esto todas las veces que la bebiereis, en memoria de mí. 1 Corintios 11:24-25\n\n Y mientras comían, tomó Jesús el pan, y bendijo, y lo partió, y dio a sus discípulos, y dijo: Tomad, comed; esto es mi cuerpo. Mateo 26:26",
      },
    ],
  },
  RDM: RDM_KEYS,
  divinamisericordia: divineMercyPrayers,
  cierre: [
    {
      ...litanyLauretanaMeta,
      verses: litanyLauretanaVerses,
      sections: litanyLauretanaSections,
    },
    {
      id: "S",
      title: "Salve Regina",
      img: "/gallery-images/misterios/modooscuro/salve-regina.jpg",
      imgmo: "/gallery-images/misterios/modooscuro/salve-regina.jpg",
      imglight: "/gallery-images/misterios/salve-regina.jpg",
      text: "Dios te salve, Reina y Madre de misericordia, vida, dulzura y esperanza nuestra; Dios te salve. A Ti clamamos los desterrados hijos de Eva; a Ti suspiramos, gimiendo y llorando en este valle de lágrimas. Ea, pues, Señora, abogada nuestra, vuelve a nosotros esos tus ojos misericordiosos; y después de este destierro muéstranos a Jesús, fruto bendito de tu vientre. ¡Oh clemente, oh piadosa, oh dulce Virgen María! Ruega por nosotros, Santa Madre de Dios, para que seamos dignos de alcanzar las promesas de nuestro Señor Jesucristo. Amén.",
    },
    {
      id: "Papa",
      title: "Oración por el Papa",
      img: "/gallery-images/misterios/modooscuro/papa.jpg",
      imgmo: "/gallery-images/misterios/modooscuro/papa.jpg",
      imglight: "/gallery-images/misterios/litografia/ezekielv.jpg",
      text: "Oh Dios, que has puesto la sede de Pedro como fundamento de la unidad de la Iglesia, concede al Papa Francisco, tu siervo, ser para todos los fieles principio y fundamento visible de la fe y de la comunión. Por Jesucristo, nuestro Señor. Amén. En el nombre del Padre, y del Hijo, y del Espíritu Santo. Amén.",
    },
  ],
};

export default RosarioPrayerBook;
